
import Vue from "vue";
import _ from "lodash";
import store from "../../store/session";
import { TranslateServiceBuilder } from "../../services/Translate/translateServiceBuilder";
import { ClientOrder } from "../../model/entity/client_order";
import notificationMixin from "../../mixin/notification";
import moment from "moment";

const translate = TranslateServiceBuilder.Instance()._;
const ModalPopup = () => import("../elements/QModal.vue");
const MenuDetailPopup = () => import("../compositions/SOMenuDetailPopup.vue");
let menuPopup;

export default Vue.component("SOCart", {
  components: {
    QTranslate: () => import("../elements/QTranslate.vue"),
    QSkeleton: () => import("../elements/QSkeleton.vue"),
    QButton: () => import("../elements/QButton.vue"),
    QAlert: () => import("../elements/QAlert.vue"),
    QError: () => import("../elements/QError.vue")
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  mixins: [notificationMixin],
  data() {
    return {
      toggleOpen: false,
      errMessage: "",
      isDeliver: "0",
      selectPopup: false,
      stockErrorPopup: false,
    };
  },
  watch: {
    orders: {
      deep: true,
      handler() {
        if (this.orders.length === 0) {
          this.close();
        }
      }
    },
    "$route.hash"() {
      if (menuPopup && !this.$route.hash) {
        menuPopup.remove();
        menuPopup = null;
        this.open();
      }
    }
  },
  computed: {
    errors() {
      return store.state.errors || {};
    },
    orders() {
      const orders = store.state.cart.orders;
      this.errMessage = ''; // clear msg when update order
      return orders
    },
    cartStyle(): object {
      if (this.isOpen) {
        return {
          display: "block"
        };
      }

      return {
        display: "none"
      };
    },
    cartClass(): object {
      return {
        open: this.isOpen
      };
    },
    cartAreaClass(): string {
      if (this.isOpen) {
        return "Title mb__iphone-x-bottom open";
      }

      return "Title mb__iphone-x-bottom";
    },
    last_order_time() {
      let result = null;

      _.map(
        store.state.shop.last_order_times, function (item) {
          let current = moment.duration(moment().format("HH:mm"));
          let last_order_time = moment.duration(item.time);
          let difference = last_order_time.subtract(current);

          if (0 <= difference.asMinutes() && difference.asMinutes() <= 10) {
            result = item.time;
          }
        });

      return result;
    },
    // ODR-1629: ポップアップに出す不足商品一覧（名前と状態）
    shortageItems() {
      const ss = store.state.stockShortage;
      if (!ss || !ss.shortage) {
        return [];
      }
      const toState = (item) =>
        item.is_soldout ? "売り切れ" : `在庫${item.remain_order}個`;
      const menus = (ss.shortage.menus || []).map((m) => ({
        name: m.name,
        state: toState(m),
      }));
      const options = (ss.shortage.options || []).map((o) => ({
        name: o.name,
        state: toState(o),
      }));

      return [...menus, ...options];
    },
  },
  methods: {
    handleClickOpenButton() {
      this.toggleOpen();
    },
    handleClickToggleCart() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },
    handleClickOrder() {
      if (store.state.isOrdering) {
        return;
      }
      // ODR-1612: 受け取り方法の選択は配膳型のみ。セルフ型はお客様が厨房まで
      // 取りに来るので選択の余地がなく、ポップアップを出さずそのまま注文確定する
      // （is_deliver は初期値 "0" ＝「取りに行く」のまま送られる）。
      // has_guide は従来お客様側に配信されていなかったため、フロントが先に配信された
      // 過渡期は undefined になりうる。その場合は従来どおり表示する（配膳型店舗で
      // 選択が消える事故を防ぐ安全側の判定）。
      const isServingType = store.state.shop.has_guide !== false;
      if (store.state.shop.is_select_receive && isServingType) {
        this.openSelectPopup();
      } else {
        this.submitOrder();
      }
    },
    handleClickCloseModal: function () {
      this.closeSelectPopup();
    },

    submitOrder: function () {
      this.errMessage = "";
      this.closeSelectPopup();
      this.$emit("close");
      store.dispatch("postOrder", this.isDeliver).catch((err: any) => {
        // ODR-1629: 在庫不足はポップアップ＋カートを開いて各行に理由表示
        if (err && err.isStockShortage) {
          this.open();
          this.stockErrorPopup = true;
          return;
        }
        this.showErrorNotification(err.message);
        this.open();
        this.errMessage = err.message;
      });
    },
    handleClickCloseStockError() {
      this.stockErrorPopup = false;
      // 閉じたらカートを開いた状態にして、各行の理由を確認・修正できるようにする
      this.open();
    },

    openSelectPopup() {
      this.isDeliver = "0";
      this.selectPopup = true;
    },
    closeSelectPopup() {
      this.selectPopup = false;
    },

    menuName(key: string) {
      const menu = store.state.cacheMenus[key];
      if (!menu) {
        return null;
      }

      return _.cloneDeep(menu).name;
    },
    menuAlcohol(key: string): boolean {
      const menu = store.state.cacheMenus[key];
      if (!menu) {
        return false;
      }

      return _.cloneDeep(menu).is_liquor_tax;
    },
    menuOptionName(key: string) {
      const menuMenusOption = store.state.cacheMenusMenuOption[key];
      if (!menuMenusOption) {
        return null;
      }

      const menuOption =
        store.state.cacheMenuOptions[
          _.cloneDeep(menuMenusOption).menu_option_id
        ];
      if (!menuOption) {
        return null;
      }

      return _.cloneDeep(menuOption).title;
    },
    menuMenusOptionName(key: string) {
      const menuMenusOption = store.state.cacheMenusMenuOption[key];
      if (!menuMenusOption) {
        return null;
      }

      return _.cloneDeep(menuMenusOption).menu.name;
    },

    // ODR-1629: カート行のメニュー在庫不足の理由文言（売切れ/在庫超過）。null なら不足なし。
    stockReason(order) {
      const ss = store.state.stockShortage;
      if (!ss || !ss.stock || !ss.stock.menus) {
        return null;
      }
      const s = ss.stock.menus[order.id];
      if (!s) {
        return null;
      }
      if (s.is_soldout) {
        return "売り切れのため注文できません。";
      }
      if (s.is_set_maximum_order_per_day) {
        // 同一メニューをカート内で合計して残数と比較
        const total = this.orders
          .filter((o) => o.id === order.id)
          .reduce((a, o) => a + o.quantity, 0);
        if (total > s.remain_order) {
          return `在庫は${s.remain_order}個です。`;
        }
      }

      return null;
    },
    // ODR-1629: カート行のオプション在庫不足の理由文言の配列。
    optionStockReasons(order) {
      const ss = store.state.stockShortage;
      if (!ss || !ss.stock || !ss.stock.options) {
        return [];
      }
      const result = [];
      (order.options || []).forEach((opt) => {
        const mmo = store.state.cacheMenusMenuOption[opt.option_id];
        if (!mmo || !mmo.menu) {
          return;
        }
        const optMenuId = mmo.menu.id;
        const s = ss.stock.options[optMenuId];
        if (!s) {
          return;
        }
        const name = mmo.menu.name || "";
        if (s.is_soldout) {
          result.push(`「${name}」が売り切れのため注文できません。`);

          return;
        }
        if (s.is_set_maximum_order_per_day) {
          const total = this.orders.reduce((sum, o) => {
            return (
              sum +
              (o.options || [])
                .filter((t) => {
                  const m = store.state.cacheMenusMenuOption[t.option_id];

                  return m && m.menu && m.menu.id === optMenuId;
                })
                .reduce((a, t) => a + t.quantity, 0)
            );
          }, 0);
          if (total > s.remain_order) {
            result.push(`「${name}」の在庫は${s.remain_order}個です。`);
          }
        }
      });

      return result;
    },
    // ODR-1629: この行に在庫不足（メニュー or オプション）があるか。枠の強調表示に使う。
    hasStockNg(order) {
      return !!this.stockReason(order) || this.optionStockReasons(order).length > 0;
    },

    close() {
      this.$emit("close");
    },
    open() {
      this.$emit("open");
    },
    handleClickEditOrder(index: number, order: ClientOrder) {
      this.showMenuDetail(order.id, index, order);
    },
    showMenuDetail(menuId: string, index: number, order: ClientOrder) {
      MenuDetailPopup().then(Popup => {
        if (menuPopup) {
          menuPopup.remove();
          menuPopup = null;
        }
        const optionids = _.map(order.options, opt => {
          return opt.option_id;
        });

        menuPopup = new Popup.default({
          propsData: {
            parent: this.$parent.$el,
            isOpen: true,
            allowRemove: true,
            menuId,
            order: {
              id: menuId,
              quantity: order.quantity,
              options: optionids
            }
          }
        });
        menuPopup.$on("update", order => {
          store.dispatch("addOrder", {
            order: {
              id: order.menuId,
              quantity: order.quantity,
              options: _.map(order.options, opt => {
                return {
                  option_id: opt,
                  quantity: order.quantity
                };
              })
            },
            index
          });
        });

        menuPopup.$on("remove", opt => {
          store.dispatch("removeOrder", {
            index
          });
        });

        menuPopup.$on("close", () => {
          this.$router.push(`#`);
          this.open();
        });

        menuPopup.$mount();
        this.close();
        this.$router.push(`#open`);
      });
    },
    isDisableOrder(order) {
      let result = false;

      if (order.length < 1) {
        return true;
      }

      _.map(
        store.state.shop.last_order_times, function (item) {
          let last_order_time = item.time;
          let release_time = moment(item.time, "HH:mm").add(item.release_time, 'minutes').format("HH:mm");
          let current = moment().format("HH:mm");

          if (last_order_time <= current && current <= release_time) {
            result = true;
          }
        });

      return result
    }
  }
});
